document.addEventListener('DOMContentLoaded', () => {
  const configEl = document.querySelector('#fp-options-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent.trim());
  } catch (e) {
    console.error('Invalid JSON in custom.options_config metafield:', e);
    return;
  }

  const root = document.querySelector('#fp-options-root');
  if (!root) return;

  const productForm = document.querySelector('product-form form');
  const currentPath = window.location.pathname.replace(/\/+$/, '');

  function setHiddenOption(index, label, value) {
    if (!productForm) return;

    const cleanLabel = (label || `Option ${index + 1}`).trim();
    const inputName = `properties[${cleanLabel}]`;

    let input = productForm.querySelector(`input[name="${inputName}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      productForm.appendChild(input);
    }
    input.value = value;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'fp-options-wrapper';

  (config.options || []).forEach((opt, index) => {
    const group = document.createElement('div');
    group.className = 'fp-option-group';

    const labelEl = document.createElement('div');
    labelEl.className = 'fp-option-label';
    labelEl.textContent = opt.label || `Option ${index + 1}`;
    group.appendChild(labelEl);

    // RADIO OPTIONS WITH ICONS
    if (opt.type === 'radio') {
      (opt.values || []).forEach(rawValue => {
        const valueObj =
          typeof rawValue === 'string' ? { label: rawValue } : rawValue || {};

        const labelText = valueObj.label || '';
        const targetUrl = valueObj.url || null;
        const variantId = valueObj.variant_id || null;
        const iconUrl = valueObj.icon || null;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fp-option-btn';

        if (iconUrl) {
            btn.innerHTML = `
                <div class="fp-option-tile">
                <div class="fp-option-icon-wrap">
                    <img src="${iconUrl}" alt="${labelText}" class="fp-option-icon">
                </div>
                <div class="fp-option-text">${labelText}</div>
                </div>
            `;
            } else {
            btn.textContent = labelText;
            }


        btn.addEventListener('click', () => {
          group.querySelectorAll('.fp-option-btn').forEach(s =>
            s.classList.remove('active')
          );
          btn.classList.add('active');

          setHiddenOption(index, opt.name || opt.label, labelText);

          if (targetUrl) {
            window.location.href = targetUrl;
            return;
          }

          if (variantId && productForm) {
            const idInput = productForm.querySelector('input[name="id"]');
            if (idInput) {
              idInput.value = variantId;
            }
          }
        });

        // Auto-highlight if this button matches current URL
        if (targetUrl) {
          try {
            const urlObj = new URL(targetUrl, window.location.origin);
            const btnPath = urlObj.pathname.replace(/\/+$/, '');
            if (btnPath === currentPath) {
              btn.classList.add('active');
              setHiddenOption(index, opt.name || opt.label, labelText);
            }
          } catch (e) {
            console.warn('Invalid targetUrl in options_config:', targetUrl);
          }
        }

        group.appendChild(btn);
      });
    }

    // DROPDOWN (still supported if you ever need it)
    if (opt.type === 'dropdown') {
      const select = document.createElement('select');
      select.className = 'fp-option-select';

      (opt.values || []).forEach(rawValue => {
        const valueObj =
          typeof rawValue === 'string' ? { label: rawValue } : rawValue || {};
        const labelText = valueObj.label || '';

        const optionEl = document.createElement('option');
        optionEl.value = labelText;
        optionEl.textContent = labelText;
        select.appendChild(optionEl);
      });

      if (opt.values && opt.values.length > 0) {
        const first =
          typeof opt.values[0] === 'string'
            ? opt.values[0]
            : opt.values[0].label || '';
        setHiddenOption(index, opt.name || opt.label, first);
      }

      select.addEventListener('change', () => {
        setHiddenOption(index, opt.name || opt.label, select.value);
      });

      group.appendChild(select);
    }

    wrapper.appendChild(group);
  });

  root.appendChild(wrapper);
});
